import { RmaEntityTypeCodes, RmaTaxIdTypes } from '@harvestiq/constants';
import { isIndividualEntity } from './is-individual-entity';

// See: RMA https://pubfs-rma.fpac.usda.gov/pub/References/insurance_control_elements/PASS/2026/2026_D00019_IceIdTypeEntityTypePrimaryProducer_YTD.txt
// and https://pubfs-rma.fpac.usda.gov/pub/References/insurance_control_elements/PASS/2026/2026_D00021_IceIdTypeEntityTypeSbi_YTD.txt
// NOTE: This focus on firstname/last name entity names only
// The same ICE's define that the business name is always allowed
export function isEntityFirstNameLastNameAllowed({
  taxIdType,
  entityTypeCode,
}: {
  taxIdType?: RmaTaxIdTypes | null;
  entityTypeCode: RmaEntityTypeCodes;
}): boolean {
  if (taxIdType === RmaTaxIdTypes.SSN) {
    switch (entityTypeCode) {
      case RmaEntityTypeCodes.Individuals:
      case RmaEntityTypeCodes.TransferOfRightToIndemnity:
      case RmaEntityTypeCodes.JointOperationsVenturesAndCoOwnerships:
      case RmaEntityTypeCodes.TrustRevocable:
      case RmaEntityTypeCodes.SpousalMarried:
        return true;

      default:
        return false; // Default to false if not allowed or not covered/listed
    }
  }

  if (taxIdType === RmaTaxIdTypes.EIN) {
    switch (entityTypeCode) {
      case RmaEntityTypeCodes.Estates:
      case RmaEntityTypeCodes.TransferOfRightToIndemnity:
      case RmaEntityTypeCodes.JointOperationsVenturesAndCoOwnerships:
      case RmaEntityTypeCodes.Partnership:
      case RmaEntityTypeCodes.TrustRevocable:
      case RmaEntityTypeCodes.TrustIrrevocable:
      case RmaEntityTypeCodes.IndividualOperatingAsABusiness:
        return true;

      default:
        return false; // Default to false if not allowed or not covered/listed
    }
  }

  if (taxIdType === RmaTaxIdTypes.RMAIssued) {
    switch (entityTypeCode) {
      case RmaEntityTypeCodes.TransferOfRightToIndemnity:
      case RmaEntityTypeCodes.Individuals:
      case RmaEntityTypeCodes.JointOperationsVenturesAndCoOwnerships:
      case RmaEntityTypeCodes.TrustRevocable:
      case RmaEntityTypeCodes.SpousalMarried:
        return true;

      default:
        return false; // Default to false if not allowed or not covered/listed
    }
  }

  if (taxIdType === RmaTaxIdTypes.BureauOfIndianAffairs) {
    return false; // No entity names allowed for this Tax ID Type
  }

  return isIndividualEntity({ type: entityTypeCode }); // Fallback to the old logic as taxId is not always existent
}

export function isEntityFirstNameLastNameAllowedAndAvailable({
  taxIdType,
  entityTypeCode,
  firstName,
  lastName,
}: {
  taxIdType?: RmaTaxIdTypes | null;
  entityTypeCode: RmaEntityTypeCodes;
  firstName?: string | null;
  lastName?: string | null;
}): boolean {
  const isEntityNameAllowed = isEntityFirstNameLastNameAllowed({
    taxIdType,
    entityTypeCode,
  });
  const isNameAvailable = Boolean(firstName || lastName);
  return isEntityNameAllowed && isNameAvailable;
}
